import { render, staticRenderFns } from "./addAssignWork.vue?vue&type=template&id=15b6dfe4&scoped=true"
import script from "./addAssignWork.vue?vue&type=script&lang=js"
export * from "./addAssignWork.vue?vue&type=script&lang=js"
import style0 from "./addAssignWork.vue?vue&type=style&index=0&id=15b6dfe4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b6dfe4",
  null
  
)

export default component.exports